import { APIExtRoutes } from "@constants";
import { FeatureTemplateListDTO } from "@models/feature-template/entities/featureTemplate";

export class AnalysisFeatureTemplateConfigs {
  static readonly DefaultODataRoute = APIExtRoutes.odataFeatureTemplate;

  static readonly PickColumns: (keyof FeatureTemplateListDTO)[] = [
    "id",
    "name",
    "notes",
    "ownerName",
    "ownerAvatarUrl",
    "lastModifiedDate",
    "selectedFeatures",
    "totalFeatures",
    "status",
  ];

  static readonly GlobalFilterColumns: (keyof FeatureTemplateListDTO)[] = [
    "name",
    "ownerName",
  ];
}
